import { NgModule } from '@angular/core';
import { SemanticPathService as CxSemanticPathService, UrlModule as CxUrlModule } from '@spartacus/core';
import { SemanticPathService as PySemanticPathService } from './semantic-path.service';

@NgModule({
  exports: [CxUrlModule],
  providers: [{ provide: CxSemanticPathService, useExisting: PySemanticPathService }],
})
export class UrlModule {}
